import { moveSelectedToProject } from "../../../actions/project";
import { addTask } from "../../../actions/task/add";
import { deleteSelectedTasks } from "../../../actions/task/delete";
import { duplicateSelectedTasks } from "../../../actions/task/duplicate";
import { copySelectedTasks } from "../../../actions/task/copy";
import { pasteCopiedTasks } from "../../../actions/task/paste";
import { indentSelectedTasks } from "../../../actions/task/indent";
import { unindentSelectedTasks } from "../../../actions/task/unindent";
import { setPrioritySelectedTasks } from "../../../actions/task/priority";
import { isSameId } from "../../../helpers";
import { getMenuOptions } from "../../../data/menu";
export default function (store, id, actions) {
    if (!actions)
        return;
    const { menuState } = store.getState();
    let action = actions;
    const separatorIndex = actions.indexOf(":");
    if (separatorIndex > 0) {
        action = actions.substring(0, separatorIndex);
    }
    if (action) {
        const task = store.getTask(id);
        let activeId = actions.substring(separatorIndex + 1);
        switch (action) {
            case "addBelow":
                addTask({ store, task });
                break;
            case "addSubtask":
                addTask({
                    store,
                    task: {
                        ...task,
                        parent: id,
                        targetId: id,
                    },
                });
                if (task?.collapsed && store.hasChildren(id)) {
                    store.in.exec("expand-task", { id });
                }
                break;
            case "duplicate":
                duplicateSelectedTasks({ store });
                break;
            case "delete":
                deleteSelectedTasks({ store });
                break;
            case "indent":
                indentSelectedTasks({ store });
                break;
            case "unindent":
                unindentSelectedTasks({ store });
                break;
            case "copy":
                copySelectedTasks({ store });
                break;
            case "paste":
                pasteCopiedTasks({ store, id });
                break;
            case "priority":
                setPrioritySelectedTasks({ store, priority: activeId });
                break;
            case "assign":
                if (task?.assigned?.some(i => isSameId(i, activeId))) {
                    store.in.exec("unassign-user", {
                        id,
                        userId: activeId,
                    });
                }
                else {
                    store.in.exec("assign-user", {
                        id,
                        userId: activeId,
                    });
                }
                let { menuState, menu } = store.getState();
                if (menu === true) {
                    menu = getMenuOptions;
                }
                let options = menu({
                    store,
                    type: "task",
                    source: menuState.source,
                });
                if (options === true) {
                    options = getMenuOptions({
                        store,
                        type: "task",
                        source: menuState.source,
                    });
                }
                store.setState({
                    menuState: {
                        ...menuState,
                        options: options,
                    },
                });
                break;
            case "moveProject":
                if (activeId === "null")
                    activeId = null;
                moveSelectedToProject({
                    store,
                    id: activeId,
                });
                break;
        }
    }
    if (action !== "assign") {
        store.in.exec("close-menu", { ...menuState });
    }
}
//# sourceMappingURL=task.js.map